<template>
  <v-select
    v-model="level"
    :items="levels"
    label="Difficulty"
    background-color="grey lighten-5"
    class="pt-1"
    dense
    solo
    flat
    item-text="name"
    item-value="value"
    hide-details
  />
</template>

<script>
export default {
  name: 'DifficultySelect',
  props: {
    value: {
      type: [String, Number, null],
      default: null
    }
  },
  data () {
    return {
      level: this.value,
      defaultLevels: [
        { name: 'All', value: -1 }
      ],
      levels: []
    }
  },
  watch: {
    level (newVal) {
      this.$emit('update', newVal)
    },
    value (newVal) {
      this.level = newVal
    }
  },
  async mounted () {
    const { data } = await this.$axios.get(this.$store.getters.projectPath + '/configs/telemetry/difficulty')
    .catch(error => ({ data: { err: true, message: error.response.data } }))

    if (data.err) {
      this.$toasted.error(data.message)
    } else {
      this.levels = this.defaultLevels.concat(data)
    }
  }
}
</script>